import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AckRequest } from 'src/app/models/ack-request';
import { AckRequestService } from 'src/app/services/ack-request.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { MyOrdersService } from '../my-orders-table/my-orders-table.service';

@Component({
  selector: 'logzy-request-accept-form',
  templateUrl: './request-accept-form.component.html',
  styleUrls: ['./request-accept-form.component.scss']
})
export class RequestAcceptFormComponent implements OnInit {
  @Input() changeToStatus = null;
  errorObj: any = {};
  open1: string = "sidepanel";
  canvas: string = "Canvas";
  modelService: MyOrdersService;
  ackService: AckRequestService;
  @Input() showPreviousQuotes: boolean = true;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() updateAction: EventEmitter<any> = new EventEmitter();

  constructor(
    private ackRequest: AckRequestService,
    private myOrderService: MyOrdersService
    , private snackBar: MatSnackBar,) { }

  @Input()
  aceptObject: AckRequest;

  defaultaccept: AckRequest = {
    id: null,
    remarks: "OK",
  }
  ngOnInit(): void {
    this.aceptObject = { ...this.defaultaccept };
    this.modelService = this.myOrderService;
    this.ackService = this.ackRequest;
  }
  acceptRequest() {
    this.ackRequest.acceptRequest(this.aceptObject, this.ackService.selectedRequest.id).subscribe({
      next: response => {
        this.snackBar.open("Request Accepted Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.close.emit(this.aceptObject);
        this.updateAction.emit();
        // this.modelService.getRequestDetails();
        // this.myOrderService.getRequestDetailsByGroup();
        // this.closeEdit();
        // return response;
      },
      error: error => {
        return this.catchError(error);
      }
    })
  }
  // Function to catch errors
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj.remarks);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }

  closeEdit() {
    this.open1 = " sidepanel ";
    this.canvas = "Canvas ";
  }
  // getNatureOfRequest(request: any) {
  //   switch (request.request_type.dev_name) {
  //     case 'lease':
  //       return 'Lease';
  //     case 'one_way':
  //       if (request.transaction_type == 'use')
  //         return 'One Way-Use';
  //       else
  //         return 'One Way-Supply';
  //     case 'buy_sell':
  //       if (request.transaction_type == 'use')
  //         return 'Trade-Buy';
  //       else
  //         return 'Trade-Sell';

  //   }
  //   return '-';
  // }

}
